<script>
export default {
  data() {
    return {
      iframeUrl: `${process.env.VUE_APP_NEW_APP_URL}/external-product?embedded=true`,
    }
  },
  mounted() {
    this.handleMessage = event => {
      if (event.data && event.data.type === 'setHeight' && event.data.height) {
        const iframe = this.$el.querySelector('iframe')
        if (iframe) {
          iframe.style.height = `${event.data.height}px`
        }
      }
    }
    window.addEventListener('message', this.handleMessage)
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    switchToOld() {
      localStorage.setItem('externalProductPageVersion', 'old')
      window.location.reload()
    },
  },
}
</script>

<template>
  <div class="pb-50">
    <div class="alert alert-primary mb-0 mt-2 mx-2 d-flex align-items-center">
      <feather-icon
        icon="BellIcon"
        class="mr-50 mt-n25"
        size="18"
      />

      Menampilkan versi baru dari halaman tabel produk eksternal

      <button class="btn btn-primary ml-auto" @click="switchToOld">
        Buka versi lama
      </button>
    </div>

    <iframe
      :src="iframeUrl"
      width="100%"
      height="100%"
    />
  </div>
</template>

<style scoped lang="scss">

</style>
